// you're using this to get stuff from Django base template and inject into each Vue instance
var ComplianceSettingsMixin = {
    computed: {
        complianceSettings() {
            // just a single object to hold all compliance settings to share across components
            return {
                sidebarWidth: '700px',  // this is the width of the sidebars in the compliance components
            }
        },
    },
};



export {
    ComplianceSettingsMixin,
}